import React from 'react'

import { Button, Grid, Header, Image, Modal } from 'semantic-ui-react'

import ProjectOverlayFields from '../../components/project/ProjectOverlayFields'
import { ProjectAttributionSettings } from '../../utils/projectSetup'

import imageOnboardingBranding from '../../_images/onboarding-branding.png'

const ProjectThemeModal = (props: IProjectThemeModalProps) => {
  // Props
  const {
    loading,
    attributionSettings,
    handleChangeAttributionSettings,
    stepBack,
    handleSaveProject,
    handleEndOnboarding,
    watermarkUrl,
    brandColor,
  } = props

  return (
    <Modal open style={{ width: '100%', height: '100%', marginTop: '-14px' }}>
      <Modal.Content style={{ padding: 0 }}>
        <Grid style={{ height: '100vh', minHeight: '700px', margin: 0 }}>
          <Grid.Column
            only="computer"
            width={7}
            style={{ backgroundImage: 'linear-gradient(to bottom, #3121a0, #1f248e)' }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Header inverted as="h1">
                Almost done - let's tailor Vloggi to your needs
              </Header>
              <Image src={imageOnboardingBranding} width={350} alt="vloggi" />
            </div>
          </Grid.Column>
          <Grid.Column mobile={16} computer={9}>
            <div style={{ display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden' }}>
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button disabled={loading} onClick={handleEndOnboarding}>
                  Skip
                </Button>
              </div>
              <div style={{ flex: 1, overflowY: 'auto', padding: '12px clamp(24px, 5vw, 72px) 20px' }}>
                <Header as="h2">Set up watermarking and attribution</Header>
                <p>
                  Set up how each video you receive from contributors will look, denoting your brand ownership together
                  with their contribution.
                </p>
                <div style={{ marginTop: '12px' }}>
                  <ProjectOverlayFields
                    value={attributionSettings}
                    onChange={handleChangeAttributionSettings}
                    watermarkUrl={watermarkUrl}
                    brandColor={brandColor}
                  />
                </div>
              </div>
              <div
                style={{
                  alignItems: 'center',
                  background: '#fff',
                  borderTop: '1px solid #e5e5e5',
                  display: 'flex',
                  justifyContent: 'space-between',
                  padding: '12px 20px 28px',
                }}
              >
                <Button disabled={loading} onClick={stepBack}>
                  Back
                </Button>
                <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                  <span>5 / 6</span>
                  <Button primary disabled={loading} loading={loading} onClick={handleSaveProject}>
                    Create project
                  </Button>
                </div>
              </div>
            </div>
          </Grid.Column>
        </Grid>
      </Modal.Content>
    </Modal>
  )
}

interface IProjectThemeModalProps {
  loading: boolean
  attributionSettings: ProjectAttributionSettings
  handleChangeAttributionSettings: (settings: ProjectAttributionSettings) => void
  stepBack: () => void
  handleSaveProject: () => void
  handleEndOnboarding: () => void
  watermarkUrl?: string
  brandColor?: string
}

export default ProjectThemeModal
